import React, { ChangeEvent, useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link, useLocation } from "react-router-dom";

import {
  GlobalOutlined,
  LogoutOutlined,
  ScheduleOutlined,
  SettingOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useKeycloak } from "@react-keycloak/web";

import { Menu } from "antd";

import { LanguageContext } from "@app/components/language/LanguageProvider.tsx";
import { showNotification } from "@app/services/notification/showNotification.tsx";

const selectedKeyFor = (pathname: string) => {
  if (pathname.startsWith("/missions")) {
    return "/missions";
  }
  if (pathname.startsWith("/settings")) {
    return "/settings";
  }
  return "/";
};

export const CmtMenu = () => {
  const { keycloak } = useKeycloak();
  const languageContext = useContext(LanguageContext);
  const intl = useIntl();
  const { pathname } = useLocation();

  const logout = () => {
    void keycloak.logout();
  };

  if (!languageContext) {
    showNotification({
      type: "error",
      title: intl.formatMessage({
        id: "language.title",
        defaultMessage: "Error",
      }),
      description: intl.formatMessage({
        id: "language.description",
        defaultMessage: "Language switch not available",
      }),
    });
  }

  const { locale, selectLanguage } = languageContext!;

  const toggleLanguage = () => {
    const newLocale = locale === "en" ? "fr" : "en";
    const event: ChangeEvent<HTMLSelectElement> = {
      target: { value: newLocale },
    } as React.ChangeEvent<HTMLSelectElement>;
    selectLanguage(event);
  };

  return (
    <>
      <Menu
        theme="dark"
        mode="inline"
        style={{ borderInlineEnd: "none" }}
        selectedKeys={[selectedKeyFor(pathname)]}
        items={[
          {
            key: "/",
            icon: <TeamOutlined />,
            label: (
              <Link to="/">
                <FormattedMessage id="app.title" defaultMessage="Employees" />
              </Link>
            ),
          },
          {
            key: "/missions",
            icon: <ScheduleOutlined />,
            label: (
              <Link to="/missions">
                <FormattedMessage id="app.missions" defaultMessage="Missions" />
              </Link>
            ),
          },
          {
            key: "/settings",
            icon: <SettingOutlined />,
            label: (
              <Link to="/settings">
                <FormattedMessage id="app.settings" defaultMessage="Settings" />
              </Link>
            ),
          },
        ]}
      />
      <Menu
        theme="dark"
        mode="inline"
        selectable={false}
        style={{
          borderInlineEnd: "none",
          marginTop: "auto",
          paddingBottom: "1rem",
        }}
        items={[
          {
            key: "language",
            icon: <GlobalOutlined />,
            label: (
              <FormattedMessage id="app.language" defaultMessage="Language" />
            ),
            onClick: toggleLanguage,
          },
          {
            key: "logout",
            icon: <LogoutOutlined />,
            label: <FormattedMessage id="app.logout" defaultMessage="Logout" />,
            onClick: logout,
          },
        ]}
      />
    </>
  );
};
